/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RelatedEntityEdge } from './RelatedEntityEdge';
import type { RelatedEntitySummary } from './RelatedEntitySummary';

export type ListRelatedEntitiesOutput = {
    cluster_id: string;
    entity_id: string;
    target_namespace_id?: (string | null);
    direction: ListRelatedEntitiesOutput.direction;
    depth: number;
    total_matches: number;
    returned_count: number;
    truncated?: boolean;
    target_match_count?: (number | null);
    root_entity: RelatedEntitySummary;
    entities: Array<RelatedEntitySummary>;
    relationships: Array<RelatedEntityEdge>;
};

export namespace ListRelatedEntitiesOutput {

    export enum direction {
        PARENTS = 'parents',
        CHILDREN = 'children',
        BOTH = 'both',
    }


}

